import { Injectable } from '@angular/core';
import { AppAlert } from '@models';
import { Store } from '@ngrx/store';
import { alertActions, alertSelectors } from 'app/@store/stores';
import { Guid } from 'guid-typescript';
import { delay, Observable, of, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertFacade {
  constructor(private _store: Store) {
    this.alerts$ = _store.select(alertSelectors.selectAlerts);
  }

  public alerts$: Observable<AppAlert[]>;

  show(alert: AppAlert): void {
    this._store.dispatch(alertActions.showAlert({ alert }));

    of(alert)
      .pipe(
        take(1),
        delay(alert.duration || 5000),
        tap(() =>
          this._store.dispatch(alertActions.clearAlert({ name: alert.name }))
        )
      )
      .subscribe();
  }

  showInfoMessage(message: string, duration = 5000): void {
    const alert: AppAlert = {
      message,
      duration,
      type: 'info',
      name: Guid.create().toString(),
      showCloseButton: false,
    };

    this._showAlert(alert);
  }

  showSuccessMessage(message: string, duration = 5000): void {
    const alert: AppAlert = {
      message,
      duration,
      type: 'success',
      name: Guid.create().toString(),
      showCloseButton: false,
    };

    this._showAlert(alert);
  }

  showErrorMessage(message: string, duration = 5000): void {
    const alert: AppAlert = {
      message,
      duration,
      type: 'error',
      name: Guid.create().toString(),
      showCloseButton: false,
    };

    this._showAlert(alert);
  }

  private _showAlert(alert: AppAlert): void {
    this._store.dispatch(alertActions.showAlert({ alert }));

    setTimeout(
      () => this._store.dispatch(alertActions.clearAlert({ name: alert.name })),
      alert.duration
    );
  }
}
